export default __webpack_public_path__ + "static/media/before_promo.ea3b85d8.webp";